export const MAX_APP_CLIP_NOTIFICATION_DELAY_MINUTES = 8 * 60;

export const getDelayOptions = ({
  maxDelayMinutes,
}: {
  maxDelayMinutes?: number;
} = {}) => {
  const options = [
    { value: 15, label: "15 minutes later" },
    { value: 30, label: "30 minutes later" },
    { value: 60, label: "1 hour later" },
    { value: 120, label: "2 hours later" },
    { value: 240, label: "4 hours later" },
    { value: 480, label: "8 hours later" },
    { value: 1440, label: "1 day later" },
    { value: 2880, label: "2 days later" },
    { value: 4320, label: "3 days later" },
    { value: 10080, label: "1 week later" },
  ];

  if (!maxDelayMinutes) {
    return options;
  }

  return options.filter((option) => option.value <= maxDelayMinutes);
};
